import CustomButton from "@components/buttons/CustomButton";
import SlidingPanel from "@components/sliders/SlidingPanel";
import React from "react";

interface ReverseAlertSlidingPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
  escrowAmount: string;
  buttonLoading: boolean;
}
const ReverseAlertSlider: React.FC<ReverseAlertSlidingPanelProps> = ({
  isOpen,
  onClose,
  onClick,
  escrowAmount,
  buttonLoading,
}) => {
  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={"Confirm Escrow Release"}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className={`flex flex-col gap-[16px] p-[16px]`}>
        <p className="text-text-base text-[14px] font-normal">
          Are you sure you want to reverse the escrow in favour of the seller?
        </p>
        <div className="flex px-[12px] py-[8px] bg-bg-base border border-border-subtle rounded-lg text-text-base text-[12px] font-bold text-center justify-center">
          Escrow Amount: {escrowAmount} USDT
        </div>
        <CustomButton
          text={"RELEASE ESCROW TO SELLER"}
          isActive={true}
          onClick={onClick}
          isButtonLoading={buttonLoading}
        />
      </div>
    </SlidingPanel>
  );
};

export default ReverseAlertSlider;
